import React from 'react';
import Button from '@mui/material/Button';
import './iconButton.css';

const IconButton = ({ icon: Icon, text, onClick, styleClass, ...props }) => {
  return (
    <Button
      disableRipple
      className={`icon-button ${styleClass || ''}`}
      onClick={onClick}
      {...props}
    >
      {Icon && <Icon />}
      {text}
    </Button>
  );
};

export default IconButton;
